import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppBundle from '@/plugins/graphql/queries/v2/app-bundle.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ConfirmationDialog from '@/components/BaseConfirmDialog.vue';
import FaqManager from '@/components/v2/FaqManager.vue';
import Draggable from 'vuedraggable';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import VEditorField from '@/components/v2/VEditorField.vue';
import { required } from 'vuelidate/lib/validators';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FaqUpdate from '@/plugins/graphql/mutations/v2/faq-update.gql';
import FaqFragment from '@/plugins/graphql/fragments/v2/faq.gql';
import FaqDetails from '@/plugins/graphql/queries/v2/faq.gql';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import Uploader from '@/components/v2/Uploader';
import { FileUploadInputModel } from '@/helpers/entities/models/FileUploadInputModel';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
import { isNotEmpty } from '@/helpers';
import { PhotoModel } from '@/helpers/entities/models/PhotoModel';
import FaqUploadImages from '@/plugins/graphql/mutations/v2/faq-upload-images.gql';
import FaqRemoveImages from '@/plugins/graphql/mutations/v2/faq-remove-images.gql';
let Faqs = class Faqs extends Mixins(ViewportSizeMixin, AlertMixin, ButtonLoaderMixin, GraphqlErrorMixin, Mixins(RouterParamsAppMixin, CleverTapEventsMixin, FormMixin, ImageUploadMixin)) {
    constructor() {
        super(...arguments);
        this.toggleConfirm = false;
        // FAQs search filter by answer and/or question
        this.searchFaq = '';
        this.selectedFaqUuid = null;
        this.hasSubmitted = false;
        this.form = {
            question: '',
            answer: '',
            active: true,
            uuid: '',
            images: [],
        };
        this.clickOutsideHandler = null;
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
        this.previousValue = '';
    }
    get headers() {
        return [
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
            {
                text: 'QUESTION',
                value: 'question',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ANSWER',
                value: 'answer',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACTIVE',
                value: 'active',
                align: 'left',
                sortable: false,
                switchable: true,
            },
        ];
    }
    toggleConfirmation() {
        this.toggleConfirm = true;
    }
    keywordHiglighter(text) {
        const query = (this.searchFaq || '').trim().toLowerCase();
        if (query === '')
            return text;
        const regex = new RegExp(`(?!<[^>]*>)(${query})(?![^<]*>)`, 'gi');
        return text.replace(regex, `<span class="highlight">$1</span>`);
    }
    get questionErrors() {
        const errors = [];
        if (!this.$v.form.question.$dirty) {
            return errors;
        }
        if (!this.$v.form.question.required) {
            const msg = requiredProperty('Question');
            errors.push(msg);
        }
        return errors;
    }
    get answerErrors() {
        const errors = [];
        if (!this.$v.form.answer.$dirty) {
            return errors;
        }
        if (!this.$v.form.answer.required) {
            const msg = requiredProperty('Answer');
            errors.push(msg);
        }
        return errors;
    }
    get htmlError() {
        if (this.hasSubmitted) {
            const strippedAnswer = this.stripHtmlTags(this.form.answer || '');
            if (strippedAnswer.length === 0) {
                return ['Answer is required'];
            }
        }
        return [];
    }
    stripHtmlTags(input) {
        return input.replace(/<[^>]*>/g, '').trim();
    }
    editForm(item) {
        if (item.uuid === this.selectedFaqUuid) {
            return;
        }
        if (this.sizeChecker()) {
            return;
        }
        this.selectedFaqUuid = item.uuid;
        this.form.question = item.question || '';
        this.form.answer = item.answer || '';
        this.form.images = [];
        if (item.images && item.images.length > 0) {
            this.form.images = item.images.map((image) => {
                const photoInstance = image instanceof PhotoModel ? image : new PhotoModel(image);
                return new FileUploadInputModel(photoInstance);
            });
        }
        this.form.images = [...this.form.images];
        this.$nextTick(() => {
            const clickOutsideHandler = (event) => this.handleClickOutside(event, item);
            document.addEventListener('mousedown', clickOutsideHandler);
            this.clickOutsideHandler = clickOutsideHandler;
        });
    }
    beforeDestroy() {
        if (this.clickOutsideHandler) {
            document.removeEventListener('mousedown', this.clickOutsideHandler);
        }
    }
    handleClickOutside(event, item) {
        const rows = Array.isArray(this.$refs.faqRow) ? this.$refs.faqRow : [this.$refs.faqRow];
        const row = rows.find((r) => r.dataset.uuid === this.selectedFaqUuid);
        if (row && !row.contains(event.target)) {
            this.triggerUpdate(item, null);
        }
    }
    sizeChecker() {
        const fileSizeError = this.$refs.uploader?.[0]?.$data?.fileSizeError;
        if (fileSizeError) {
            this.errorNotification('File is too big. Max file size 5MB.');
            return true;
        }
        return false;
    }
    triggerUpdate(item, previousAnswer) {
        const latestAnswer = previousAnswer || this.form.answer;
        if (this.sizeChecker()) {
            return;
        }
        this.form.uuid = this.selectedFaqUuid || item.uuid;
        const formData = {
            ...this.form,
            answer: latestAnswer,
            images: this.form.images
                .map((image) => {
                if (image instanceof FileUploadInputModel) {
                    return image;
                }
                return image.file ? new FileUploadInputModel(image.file) : null;
            })
                .filter((image) => image !== null),
        };
        this.hasSubmitted = true;
        this.update(formData);
        this.selectedFaqUuid = null;
    }
    get checkImageUnshow() {
        const activeImages = this.form.images.filter((image) => image.state !== 'deleted').length;
        return activeImages >= 3;
    }
    get checkImageUnshow1() {
        if (this.form.images.length) {
            const imageStates = this.form.images.map((image) => image.state);
            if (imageStates.every((state) => state === 'deleted')) {
                return false;
            }
            if (imageStates.some((state) => state === 'new' || state === 'idle')) {
                return true;
            }
        }
        return false;
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
        this.errorNotification('Exceeded total Number of files');
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    handleKeyDown(event, item) {
        if (event.key === 'Enter') {
            if (item) {
                const previousAnswer = this.previousValue;
                this.triggerUpdate(item, previousAnswer);
            }
        }
    }
    onEditorValueChanged(newValue, oldValue) {
        if (oldValue !== undefined) {
            this.previousValue = oldValue;
        }
        this.$emit('input', newValue);
    }
    async update(form) {
        try {
            const deletedImagesUuids = this.getDeletedImageUuids(form.images);
            const newImages = this.filterNewImages(form.images);
            const { question, answer, active } = form;
            const faqUUID = form.uuid;
            await this.$apollo.mutate({
                mutation: FaqUpdate,
                variables: {
                    input: {
                        question,
                        answer,
                        active,
                        faqUuid: form.uuid,
                    },
                },
                update(cache, { data }) {
                    const { faq } = data.faqUpdate;
                    faq.uuid = faqUUID;
                    cache.writeFragment({
                        id: faqUUID,
                        fragment: FaqFragment,
                        data: faq,
                        fragmentName: 'Faq',
                    });
                    cache.writeQuery({
                        query: FaqDetails,
                        variables: {
                            faqUUID,
                        },
                        data: {
                            fetchSpecificFaq: faq,
                        },
                    });
                },
            });
            if (form.images.length > 0) {
                if (isNotEmpty(deletedImagesUuids.length)) {
                    await this.deleteImages(deletedImagesUuids, faqUUID || '');
                }
                if (isNotEmpty(newImages.length)) {
                    await this.imageUploader(newImages, faqUUID || '');
                }
                this.$emit('faq-updated');
            }
        }
        catch (error) {
            console.error('Error during FAQ update mutation: ', error);
            throw error;
        }
    }
    async imageUploader(images, faqUuid) {
        const inputImages = images.map((input) => input.file);
        await this.$apollo.mutate({
            mutation: FaqUploadImages,
            variables: {
                input: {
                    faqUuid,
                    images: inputImages,
                },
            },
            update(cache, { data }) {
                const { faq } = data.faqUploadImages;
                faq.uuid = faqUuid;
                cache.writeFragment({
                    id: faqUuid,
                    fragment: FaqFragment,
                    data: faq,
                    fragmentName: 'Faq',
                });
            },
        });
    }
    async deleteImages(imageUuids, faqUuid) {
        await this.$apollo.mutate({
            mutation: FaqRemoveImages,
            variables: {
                input: {
                    faqUuid,
                    photos: imageUuids,
                },
            },
            update(cache, { data }) {
                const { faq } = data.faqRemoveImages;
                faq.uuid = faqUuid;
                cache.writeFragment({
                    id: faqUuid,
                    fragment: FaqFragment,
                    data: faq,
                    fragmentName: 'Faq',
                });
            },
        });
    }
};
__decorate([
    Watch('form.answer', { immediate: true, deep: true })
], Faqs.prototype, "onEditorValueChanged", null);
Faqs = __decorate([
    Component({
        components: {
            PageTitle,
            FaqManager,
            ActionButton,
            AppBasicDetails,
            BaseOverlayLoader,
            ConfirmationDialog,
            Draggable,
            BaseSearchInput,
            VEditorField,
            BaseTextField,
            Uploader,
            BaseImagePlaceholder,
        },
        validations: {
            form: {
                question: { required },
                answer: { required },
            },
        },
        apollo: {
            appBundle: {
                query: AppBundle,
                variables() {
                    return { appUuid: this.appUUID };
                },
                update(data) {
                    return data.appServiceBundle.name;
                },
            },
        },
    })
], Faqs);
export default Faqs;
